import { createContext } from "react";

const LoadingContext = createContext({
  loading: true,
  showLoading: () => {},
  closeLoading: () => {},
});

export default LoadingContext;
